/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Day_MonInputs */

const en_ui_day_mon = /** @type {(inputs: Ui_Day_MonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon`)
};

const de_ui_day_mon = /** @type {(inputs: Ui_Day_MonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mo`)
};

/**
* | output |
* | --- |
* | "Mon" |
*
* @param {Ui_Day_MonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_day_mon = /** @type {((inputs?: Ui_Day_MonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Day_MonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_day_mon(inputs)
	return de_ui_day_mon(inputs)
});